import { toast } from 'react-toastify';

const infoNotification = (message = 'Success!', toastId) => {
  toast.success(message, {
    closeOnClick: true,
    className: 'bg-4',
    ...toastId && { toastId }
  });
};

export default infoNotification;
